(function(){
  'use strict';
  angular.module("irricrops")
    .directive('sidebarProfile', function() {
      return {
        restrict     : 'E',
        templateUrl  : 'shared/sidebarProfile/sidebar.tmpl.html',
        controllerAs : 'sp',
        controller   : ['global', '$mdSidenav', 'Auth', '$state', 'menu', 'File', 'urls', function(global, $mdSidenav ,Auth ,$state ,menu, File, urls){
          var vm = this;
          vm.global = global;
          vm.urls   = urls;
          vm.progress = 0;

          vm.changeLogo = function(file, invalidFiles) {
            vm.uploading = true;
            File.upload(file, invalidFiles, 'vinedo/logo-vinedo', 'archivo').then(function(res){
              vm.uploading = false;
              global.logo = res.data.logo;
              console.dir(res);
            }, function() {
              vm.uploading = false;
            }, function (evt) {
                vm.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                if (vm.progress == 100) {
                  vm.uploading = false;
                }
            });
          }

          vm.close = function () {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav('right').close();
          };

          vm.logout = function () {
            Auth.logout(function(){
              mixpanel.track("logout");
              if (mixpanel.cookie && mixpanel.cookie.clear) {
                mixpanel.cookie.clear();
                window.clearInterval("id");
              }
              var url = window.location.href;
              url = url.split("#")[1];
              $state.go("login", {
                url: url
              });
              global.clean();
              menu.clean();
              vm.close();
            });
          };



        }]
        };
    });
})();
